<script>
export default {
    name: "SupplierListing",

    data() {
        return {
            showModal: false,
            suppliers: [],
            filter:'',
        };
    },

    mounted() {
       this.fetchAll();
    },

    methods: {

       fetchAll() {
          this.$root.loading = true;
          let url=`SupplierSetup/GetSuppliers`;
          url +=this.filter ? `?SearchText=${this.filter}` : ``;
              
          this.$accountsHttp.get(url).then(response => {
             this.suppliers = response.data;
             this.$root.loading = false;
          }).catch(() => { this.$root.loading = false; });
       },
    },
}
</script>

<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <div class="flex w-full">
             <div class="flex-1"><h5 class="flex-1 text-sm">Suppliers</h5></div>
             <div class="flex-1">
                <div class="flex justify-end">
                   <router-link class="btn-info btn-sm text-xs rounded" :to="{ name : `suppliers-dashboard.suppliers.create`}"><i class="fa fa-plus"></i> Supplier</router-link>
               </div>
             </div>
          </div>
        </template>
        <template v-slot:card-body>
            <div class="w-full overflow-auto">
             <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" v-model.trim="filter" 
                    @keydown.enter="fetchAll" 
                    placeholder="press enter to search only"
                    id="grid-search" class="input-control input-sm text-xs">
              </div>
                <table class="table table-hover">
                  <thead class="bg-blue-500 text-xs text-white">
                     <tr class="flex w-full">
                        <th class="p-tiny w-1/6">Name</th>
                        <th class="p-tiny w-1/6">Cell Phone</th>
                        <th class="p-tiny w-1/6">Email</th>
                        <th class="p-tiny w-1/6">KRA PIN</th>
                        <th class="p-tiny w-1/6">Bank Name</th>
                        <th class="p-tiny w-1/6">Bank Branch</th>
                        <th class="p-tiny w-1/6">Bank Sort Code</th>
                        <th class="p-tiny w-1/6">Account No</th>
                        <th class="p-tiny w-1/6">Mpesa</th>
                        <th class="p-tiny w-1/6">Postal Address</th>
                        <th class="p-tiny w-1/6">Physical Address</th>
                        <!-- <th class="p-tiny w-1/6">Latest LPO Issued</th>
                        <th class="p-tiny w-1/6">Latest Delivery</th>
                        <th class="p-tiny w-1/6">Last Date Paid</th>
                        <th class="p-tiny w-1/6">Current Bal.</th>
                        <th class="p-tiny w-1/6">Credit Limit</th>
                        <th class="p-tiny w-1/6">PD Cheque Amt</th> -->
                        <th class="p-tiny w-1/12">Active</th>
                         <th class="p-tiny w-1/12">Action</th>
                     </tr>
                  </thead>
                  <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:65vh;">
                     <tr class="w-full flex" v-for="(supplier, idx) in suppliers" :key="idx">
                        <td class="p-tiny w-1/6">{{ supplier.name }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.cellphone }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.email }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.piN_No }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.bankName }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.bankBranch }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.bankSortCode }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.accountNo }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.mpesapaybill }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.postalAddress }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.physicalAddress }}</td>
                        
                        
                        <!-- <td class="p-tiny w-1/6">{{ supplier.latest_LPO_Issued }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.latest_Delivery }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.last_Date_Paid }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.current_Bal_ }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.creditLimit }}</td>
                        <td class="p-tiny w-1/6">{{ supplier.pdChequeAmount }}</td> -->
                        <td class="p-tiny w-1/12">{{ supplier.active ? `Active` : `NA` }}</td>
                        <td class="p-tiny w-1/12 m-1">
                           <router-link class="btn-info btn-sm text-xs m-px rounded" title="View"
                               :to="{ name: 'suppliers-dashboard.suppliers.view', params: { supplierID: supplier.id } }">
                                 <i class="fa fa-eye"></i>
                           </router-link>
                           <router-link class="btn-primary btn-sm text-xs m-px rounded" title="Edit"
                               :to="{ name: `suppliers-dashboard.suppliers.edit`, params: { supplierID: supplier.id } }">
                                 <i class="fa fa-edit"></i>
                           </router-link>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
        </template>
        <template v-slot:card-footer>
           <div class="w-full text-right">
             <router-link :to="{ name: `suppliers-dashboard.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
           </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
